import { BudgetVsActualHttpService } from "./budget-vs-actual-http.service";
import { BudgetVsActualPeriod, BudgetVsActualYear } from "../models/budget-vs-actual-period.model";
import { Observable, filter, map, of, shareReplay, switchMap, take } from "rxjs";
import { Injectable } from "@angular/core";
import {EntityKey} from "@pma-entity/pma-entity-types";
import { EntityKeyService } from "@feature/pma-entity/services/entity-key.service";

@Injectable()
export class BudgetVsActualPeriodsService {

    constructor(
        private http: BudgetVsActualHttpService,
        protected entityKeyService: EntityKeyService
    ) {}

    getPeriods(propertyTaskUri: number, onlyShowFullYear): Observable<BudgetVsActualPeriod[]>{
      if(onlyShowFullYear){
        return of([{Label: 'Full Year', Value: undefined}])
      }
      return this.http.getPeriods(propertyTaskUri)
        .pipe(take(1)
          , map((periods: BudgetVsActualPeriod[]) => {
            let periodFullYear = {Label: 'Full Year', Value: undefined};
            if (periods.length <=1 )
              return [periodFullYear];

            return [periodFullYear, {Label: 'Totals', Value: undefined} ,...periods]
          })
          , shareReplay(1))
    }

    getYears(): Observable<BudgetVsActualYear[]>{
      return this.entityKeyService.getEntityKey().pipe(
        filter(key=> key != undefined && key.EntityTypeName != 'Empty Entity Key'),
        take(1),
        switchMap((key: EntityKey) => this.http.getYears(key)),
        shareReplay(1));
    }
}
